<template>
    <ul class="USPs mb-0 ml-1 p-0 pt-3 pb-sm-3 align-self-end">
        <li v-for="i in 3" :key="i.title" class="pt-3 d-flex">
            <UIIcon :name="['fa', 'check-circle']" color="#0bb40b" />
            <div>
                <div class="title">{{ translate(`USPItems${i}Title`) }}</div>
                <div class="description text-light">{{ translate(`USPItems${i}Desc`) }}</div>
            </div>
        </li>
    </ul>
</template>

<script>
import { UIIcon } from '@dundle/ui/components';
import TranslationMixin from '~/mixins/TranslationMixin';
export default {
    components: {
        UIIcon,
    },
    mixins: [TranslationMixin],
};
</script>

<style lang="scss" scoped>
.USPs {
    line-height: 1.2rem;
    list-style: none;

    .x-icon {
        height: 1.4rem;
        width: 1.4rem;
        font-size: 1.1rem;
        margin-right: 0.5rem;
        margin-top: -0.1rem;
    }

    .title {
        font-weight: bold;
        font-size: 1rem;
        color: $color-text-bold;
    }

    .description {
        font-size: 0.85rem;
    }
}
</style>
<i18n></i18n>
